import React from "react";
import dayjs from "dayjs";

interface Props {
    value: Date;
    children: React.ReactNode;
    onDateClick: (date: Date) => void;
    selectedDate: Date | null;
}

const AttendanceCalendarDateCell: React.FC<Props> = ({
                                                         value,
                                                         children,
                                                         onDateClick,
                                                         selectedDate,
                                                     }) => {
    const isSelected = dayjs(value).isSame(selectedDate, "day");

    return (
        <div
            className={`attendance-calendar-date-cell ${
                isSelected ? "selected" : ""
            }`}
            onClick={() => onDateClick(value)}
        >
            {children}
        </div>
    );
};

export default AttendanceCalendarDateCell;
